
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_196pd_9",
  "input": "awsui_input_2rhyz_196pd_13",
  "input-readonly": "awsui_input-readonly_2rhyz_196pd_62",
  "input-invalid": "awsui_input-invalid_2rhyz_196pd_106",
  "input-warning": "awsui_input-warning_2rhyz_196pd_109",
  "input-type-search": "awsui_input-type-search_2rhyz_196pd_112",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_196pd_122",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_196pd_125",
  "input-container": "awsui_input-container_2rhyz_196pd_129",
  "input-field": "awsui_input-field_2rhyz_196pd_134",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_196pd_158",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_196pd_173",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_196pd_181",
  "input-field-warning": "awsui_input-field-warning_2rhyz_196pd_194",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_196pd_207",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_196pd_207",
  "grouped": "awsui_grouped_2rhyz_196pd_222",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_196pd_228",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_196pd_232",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_196pd_238",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_196pd_242",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_196pd_246",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_196pd_252",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_196pd_256",
  "input-prefix": "awsui_input-prefix_2rhyz_196pd_261",
  "input-suffix": "awsui_input-suffix_2rhyz_196pd_262",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_196pd_276",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_196pd_285",
  "input-icon-start": "awsui_input-icon-start_2rhyz_196pd_311",
  "input-icon-end": "awsui_input-icon-end_2rhyz_196pd_318",
  "input-button-right": "awsui_input-button-right_2rhyz_196pd_324",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_196pd_328",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_196pd_331",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_196pd_335",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_196pd_338",
  "inline-label": "awsui_inline-label_2rhyz_196pd_328",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_196pd_363"
};
  